import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Input, Row, Col, Form, Radio, Tooltip } from 'antd';
import {
    theme,
    CardAnt,
    ButtonAnt,
    InputComponent,
    SelectComponent,
    Text
} from '@pfmam/pfmam';
import { Container, Box } from '../../styles/globalStyle';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';


const { TextArea } = Input;

const ButtonWrapper = styled.div`
  .anticon-check-circle {
    margin-left: 30px;
    margin-top: 2px;
  }
`;
const OverrideStyle = createGlobalStyle`
  .ant-form-item-control-input-content {
    & > span {
      width: 100%;
    }
    .primary.ant-select-single:not(.ant-select-customize-input) {
      .ant-select-selector {
        height: 52px;
        width: 100%;
        background: ${theme.colors.white};
        color: ${theme.colors.black_secondary};
        border: 1px solid ${theme.colors.grey};
        padding: 14px 20px;
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
          line-height: 20px;
        }
        .ant-select-selection-search-input {
          height: 100%;
        }
      }
      .ant-select-arrow .anticon:not(.ant-select-suffix) {
        pointer-events: none;
    }
      .ant-select-arrow {
        font-size: ${theme.font_size.size_l};
        margin-top: 0;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
      &.ant-select-focused {
        .ant-select-selector {
          box-shadow: ${theme.shadows.input_focus};
          border-color: ${theme.colors.blue_primay};
        }
          .ant-select-arrow {
          color: ${theme.colors.black_secondary};
        }
      } 
    }
  }

  
  .form-select-dropdown {
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      .ant-select-item {
        &.ant-select-item-group {
          color: ${theme.colors.grey_tertiary};
          min-height: 16px;
          line-height: 16px;
          padding: 6px 12px;
          &:hover {
            background: none;
          }
        }
      }
      .ant-select-item-option-selected,
      .ant-select-item-option-active {
        &:not(.ant-select-item-option-disabled) {
          background: ${theme.colors.white};
          font-weight: normal;
        }
      }
      .ant-select-item {
        min-height: 40px;
        line-height: 24px;
        padding: 8px 12px;
        font-size: ${theme.font_size.size_xl};
        color: ${theme.colors.black_secondary};
        font-family: 'Inter';
        &:hover {
        background: ${theme.colors.light_grey};
        font-family: 'Inter';
      }
    }
  }
`;

const Wrapper = styled.div`
  padding-top: 32px;
`;

const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
    font-weight:bold;
  }
`;

const OverrideButtonAntPermissions = styled(ButtonAnt)`
  &&& {
    background: #e0b31f;
    color: black;
    font-weight:bold;
  }
`;

const EditACHInstructionsComponent = (props) => {
    const { form, onSubmit, setPermissionsModalVisible, setIsTouched, submitted, isBankAccNumbDisabled, isNameOnAccountDisabled, initialTotalACHAccountsCount, canSubmitInstruction, formDisabled } = props;
    const primary_color = useSelector((state) => state.siteInfo.primaryColor);

    const handleBlur = (e) => {
        const value = e.target.value;
        const name = e.target.getAttribute('data-name');
        const trimmedValue = value.replace(/\n/g, "\r\n");
        form.setFieldsValue({ [name]: trimmedValue });
    }

    const handleBankNameBlur = (e) => {
        const value = e.target.value;
        const name = e.target.getAttribute('data-name');
        const trimmedValue = value.trim();
        form.setFieldsValue({ [name]: trimmedValue });
    }

    return (
        <Wrapper>
            <OverrideStyle />
            <Container>
                <CardAnt
                    cardContent={
                        <Form
                            form={form}
                            onFieldsChange={() => {
                                setIsTouched(true);
                            }}
                            name="basic"
                            layout="vertical"
                            onFinish={onSubmit}
                            requiredMark={true}
                            className="forms"
                            initialValues={{ BankAccountType: 1 }}
                        >

                            <Row gutter={40}>
                                <Col span={12}>
                                    <Form.Item label="Bank Name" name="BankName"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Bank Name Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            maxLength={23}
                                            data-name="BankName"
                                            disabled={formDisabled}
                                            placeholder="Enter Bank Name"
                                            onBlur={handleBankNameBlur}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item label="Bank Account Number" name="BankAccountNumber"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Account Number Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            maxLength={17}
                                            placeholder="Enter Linked Account Number"
                                            data-name="BankAccountNumber"
                                            disabled={formDisabled ? true : isBankAccNumbDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={40}>
                                <Col span={12}>
                                    <Form.Item label="ABA" name="ABANumber"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'ABA Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            disabled={true}
                                            maxLength={9}
                                            data-name="ABANumber"
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item label="Legal Account Owner" name="NameOnAccount"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Legal Account Owner Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            maxLength={23}
                                            placeholder="Enter Legal Account Owner"
                                            data-name="NameOnAccount"
                                            disabled={formDisabled ? true : isNameOnAccountDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* <Row gutter={40}>
                                <Col span={12}></Col>

                                <Col span={12}>
                                    <Form.Item label="Addendum Purchase Information" name="AddendaPurchase">
                                        <InputComponent
                                            type="default"
                                            maxLength={80}
                                            placeholder="Enter Addendum Puchase Information, if applicable"
                                            data-name="AddendaPurchase"
                                            disabled={formDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row> */}


                            <Row gutter={40}>
                                <Col span={12}></Col>

                                <Col span={12}>
                                    <Form.Item label="Addenda Information" name="AddendaRedemption">
                                        <InputComponent
                                            type="default"
                                            maxLength={80}
                                            placeholder="Enter Addenda Information, if applicable"
                                            data-name="AddendaRedemption"
                                            disabled={formDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={40}>
                                <Col span={12}></Col>
                                <Col span={12}>
                                    <Form.Item label="Bank Account Type" name="BankAccountType"
                                        rules={[{ required: true, message: "Bank Account Type Required" }]}
                                    >
                                        <Radio.Group disabled={formDisabled}>
                                            <Radio value={1}>Checking</Radio>
                                            <Radio value={2}>Savings</Radio>
                                            {/* <Radio value={3}>Other</Radio> */}
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={40}>
                                <Col span={12}></Col>
                                <Col span={12}>
                                    <Form.Item label={
                                        <span>
                                            Nickname&nbsp;
                                            <Tooltip title="Viewable by all team members with access to this account.">
                                                <InfoCircleOutlined style={{ fontSize: '14px' }} />
                                            </Tooltip>
                                        </span>
                                    } name="NickName">
                                        <InputComponent
                                            type="default"
                                            maxLength={50}
                                            placeholder="Enter Nickname to help identify instruction"
                                            data-name="NickName"
                                            disabled={formDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>


                            <Row>
                                <Col span={24}>
                                    {/* <Box display="flex" justifycontent="flex-end">
                                        <span style={{ color: "red" }}>*</span>
                                    </Box> */}
                                    <Box display="flex" justifycontent="flex-end">
                                        <OverrideButtonAntPermissions label="Link Account(s)" type="Secondary" onClick={() => setPermissionsModalVisible(true)} disabled={formDisabled} />
                                    </Box>
                                </Col>
                            </Row>

                            <Row>
                                <Col span={24}>
                                    <Form.Item name="ACHInstructionID" hidden>
                                        <InputComponent type="hidden" />
                                    </Form.Item>
                                    <Form.Item name="ParentID" hidden>
                                        <InputComponent type="hidden" />
                                    </Form.Item>
                                    <Form.Item name="Status" hidden>
                                        <InputComponent type="hidden" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <br></br>

                            <Box display="flex" justifycontent="center">
                                <>
                                    <OverrideButtonAnt
                                        label="Submit Changes"
                                        type="primary"
                                        htmlType="submit"
                                        linkTextColor={primary_color}
                                        loading={submitted}
                                        disabled={formDisabled ? true : initialTotalACHAccountsCount > 0 ? false : canSubmitInstruction == false ? true : false}
                                    />

                                </>
                            </Box>

                        </Form>
                    }
                    className="profile-card basic-card"
                    //title="Edit ACH Account Information"
                    title=
                    {<p>
                        <div>
                            <span>Edit Linked ACH Account</span>
                            <br />
                            <p style={{ fontStyle: "italic", fontSize: "14px", lineHeight: "20px", whiteSpace: "normal" }}>Some changes may require PFM Asset Management approval.</p>
                        </div>
                    </p>
                    }
                />

            </Container>
        </Wrapper>
    );
};

export default EditACHInstructionsComponent;